import {
  BINARY_SYSTEM,
  COLOR_HIGHLIGHTED,
  COLOR_MEDIUM,
  FONT
} from "./defaults";
import star from "./images/star.png";

function Navbar({ level, setLevel, progress, levelProgress, whichSystem, numberOfLevels}) {

  function handleDotClick(level) {
    changeLevel(level);
  }

  function changeLevel(level) {
    if (level <= progress(whichSystem)) {
      setLevel(level);
    }
  }

  return (
    <div
      style={{
        height: "1.5dvh",
        width: "80%",
        position: "relative",
        margin: "4dvh",
        marginTop: "1dvh",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderRadius: "1dvh",
      }}
    >
      {Array.from({length: numberOfLevels(whichSystem)}).map((_, index) => {

        const oneStar = (whichSystem === BINARY_SYSTEM) && ((index === 4) || (index === 5)); // Binary levels 4 and 5 will only display one star.

        const buttonStyle = (index === level) ? { // Style for button of current level.
          backgroundColor: COLOR_MEDIUM,
          cursor: "pointer",
          boxShadow: "0.4svh 0.4svh 0.3svh inset rgba(0, 0, 0, 0.5)",
          transform: "translate(0.5svh, 0.5svh)"
        } : (index <= progress(whichSystem)) ? { // Style for button of unlocked levels, except current.
          backgroundColor: COLOR_MEDIUM,
          cursor: "pointer"
        } : { // Style for button of locked levels.
          backgroundColor: "#262626",
          cursor: "not-allowed"
        };

        const starLeft = {
          left: "0.5dvh",
          opacity: levelProgress(whichSystem)[index] >= 1 ? 1 : 0.5,
          filter: levelProgress(whichSystem)[index] >= 3 ? "drop-shadow(0svh 0svh 0.3svh rgb(252, 255, 83))" : levelProgress(whichSystem)[index] >= 1 ? undefined : "none", // Progress >= 3 produces glow.
        };
        const starMiddle = {
          bottom: "0.2dvh",
          left: "50%",
          transform: "translateX(-50%)",
          opacity: levelProgress(whichSystem)[index] >= 2 ? 1 : 0.5,
          filter: levelProgress(whichSystem)[index] >= 3 ? "drop-shadow(0svh 0svh 0.3svh rgb(252, 255, 83))" : levelProgress(whichSystem)[index] >= 2 ? undefined : "none",
        };
        const starRight = {
          right: "0.43dvh", // Makes it centered with respect to the number.
          opacity: levelProgress(whichSystem)[index] >= 3 ? 1 : 0.5,
          filter: levelProgress(whichSystem)[index] >= 3 ? "drop-shadow(0svh 0svh 0.3svh rgb(252, 255, 83))" : "none",
        };

        return (
          <div style={{position: "relative"}}>
            <button
              key={index}
              onClick={() => handleDotClick(index)}
              className="navbar-button"
              style={buttonStyle}
              disabled={index > progress(whichSystem)}
            >
              {index > progress(whichSystem) && (
                <span
                  style={{
                    top: "-5%",
                    left: "0%",
                    pointerEvents: "none",
                    fontSize: "2em",
                  }}
                >
                  🔒
                </span>
              )}
              {index === level && (
                <span
                  style={{
                    fontSize: "3dvh",
                    fontFamily: FONT,
                    color: COLOR_HIGHLIGHTED,
                    textShadow: "0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5)",
                  }}
                >
                  {level + 1}
                  {Array.from({length: oneStar ? 1 : 3}).map((_, index) => {
                    
                    const starStyle = (index === 1 || oneStar) ? starMiddle : (index === 0) ? starLeft : starRight;
                    return (<img src={star} style={starStyle} className="star"/>);
                  })}
                </span>
              )}
              {index <= progress(whichSystem) && index !== level && (
                <span
                  style={{
                    fontSize: "3dvh",
                    fontFamily: FONT,
                    color: "white",
                    textShadow: "0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5)",
                  }}
                >
                  {index + 1}
                  {Array.from({length: oneStar ? 1 : 3}).map((_, index) => {
                    
                    const starStyle = (index === 1 || oneStar) ? starMiddle : (index === 0) ? starLeft : starRight;
                    return (<img src={star} style={starStyle} className="star"/>);
                  })}
                </span>
              )}
            </button>
            
          </div>
        )})}
    </div>
  );
}

export default Navbar;
